import React from "react";
import imgEye from "../../assets/hero-img/hero-eye.png";
import img01 from "../../assets/hero-img/1.png";
import img02 from "../../assets/hero-img/2.png";
import img03 from "../../assets/hero-img/3.png";
import img04 from "../../assets/hero-img/4.png";
import Dp from "../../assets/dp.png";
import DpB from "../../assets/dp2.jpg";
// import iPhone from "../../assets/i-phone.svg";
import iRegister from "../../assets/i-register.svg";
import { Link } from "react-router-dom";
import { Carousel, Accordion } from "flowbite-react";
import { RiUserShared2Fill } from "react-icons/ri";
import { RiUserSettingsFill } from "react-icons/ri";
import About from "../../components/About";
import Feedbacks from "../../components/Feedbacks/Feedbacks";
import { ChatSupport } from "../../components/ChatSupport";
import ConnectWithUs from "../../components/ConnectWithUs";


const Home = () => {
  return (
    <div className=" bg-white mt-28 flex flex-col w-full items-center justify-center ">
      <header className="flex flex-col items-center justify-center  ">
        <h1 className="mx-2 lg:mx-auto text-5xl sm:text-6xl md:text-[64px] font-bold text-myBlack flex flex-wrap flex-row justify-center">
          Welcome to{" "}
          <span className="text-myBlue">
            <span className="font-bold">AL</span>Guidance.lk
          </span>
        </h1>
        <p className="text-myBlue text-center text-sm md:text-base w-5/6 md:w-[620px]">
          start your journey with our expert tutors and advanced learning
          resources. Let’s make bio learning both effective and enjoyable!
        </p>
      </header>
      {/* ---------------------------------------Hero images----------------------------- */}
      <div className="hidden md:block flex justify-center mt-8 lg:mt-16">
        <div className="flex justify-center items-center">
          <div className="px-8 lg:px-16">
            <img src={imgEye} alt="" className=" shadow-lg rounded-xl w-full" />
            <div className=" grid grid-cols-3 gap-8 my-8">
              <img src={img01} alt="" className=" shadow-lg rounded-lg" />
              <img src={img02} alt="" className=" shadow-lg rounded-lg" />
              <img src={img03} alt="" className=" shadow-lg rounded-lg" />
              <img
                src={img04}
                alt=""
                className=" shadow-lg col-start-2 rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
      {/* -----------mobile carusel----------------- */}
      {/* ---------------------- */}
      <div className=" md:hidden px-5 mt-8">
        <img src={imgEye} alt="" className=" shadow-lg rounded-md w-full" />
      </div>
      <div
        className=" px-5  w-full  md:hidden flex flex-col md:flex-row justify-center items-center space-x-6 mx-20 mt-8"
        style={{ height: `calc(100vw - 50px)` }}
      >
        <div className="h-full w-full mx-3">
          <Carousel>
            <img src={img01} alt="..." className="h-full" />
            <img src={img02} alt="..." className="h-full" />
            <img src={img03} alt="..." className="h-full" />
            <img src={img04} alt="..." className="h-full" />
          </Carousel>
        </div>
      </div>
      {/* ----------------------- */}
      <div className="mt-28 hidden">

      <Feedbacks/>
      </div>

        <div className="mt-28 w-full h-10 blur-3xl opacity-55 bg-myBlue flex items-center justify-center">
      </div>
      <div>
        <ConnectWithUs/>
      </div>
      <div>
        <div className="bg-slate-100 grid grid-cols-1 md:grid-cols-2 mb-28">
          <div className="border flex flex-row flex-wrap justify-center py-16">
            <Link to="/register">
              <button className="size-56 flex flex-col bg-white hover:bg-slate-50 justify-center items-center rounded-2xl shadow-sm border m-3">
                <img src={iRegister} alt="register-icon" className="size-12" />
                <p className="text-2xl font-bold text-myBlue">
                  මුල් වරට register වීම සඳහා.
                </p>
              </button>
            </Link>
            <Link to="/support">
              <button className="size-56 flex flex-col bg-white hover:bg-slate-50 justify-center items-center rounded-2xl shadow-sm border m-3">
                {/* <img src={iRegister} alt="register-icon" className="size-10" /> */}
                <RiUserShared2Fill className="text-5xl text-myBlue" />
                <p className="text-2xl font-bold text-myBlue">
                  පන්ති වලට සම්බන්ධ වීම සඳහා.
                </p>
              </button>
            </Link>
            <Link to="/support">
              <button className="size-56 flex flex-col bg-white hover:bg-slate-50 justify-center items-center rounded-2xl shadow-sm border m-3">
                {/* <img src={iRegister} alt="register-icon" className="size-10" /> */}
                <RiUserSettingsFill className="text-5xl text-myBlue" />
                <p className="text-2xl font-bold text-myBlue">
                  සහාය ලබාගැනීම සඳහා.
                </p>
              </button>
            </Link>
          </div>
          <div className="bg-myBlue  md:px-16 py-16 flex flex-col items-center justify-center">
            <div className="bg-myBlue px-16 flex flex-col items-center justify-center">
              <h2 className="text-4xl font-bold text-white text-left">
                Best online tuition classes in Sri Lanka
              </h2>
              <p className="text-base font-semibold text-white text-left">
                Join us now to enjoy learning at your convenience. For any tutor
                or student who is interested to join the leading online
                education platform in Sri Lanka, please register with us.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <About/>
      {/* -----------------------FAQ-title------------------- */}
      <div className="bg-myBlue bg-opacity-10 w-full mt-28 flex items-center justify-center">
        <h2 className="font-bold  text-2xl py-2 text-myBlack">FAQs</h2>
      </div>
      {/* -----------------------FAQ------------------- */}
      <Accordion className="w-full px-8 md:px-20 mt-10 mb-28 border-none">
        <Accordion.Panel>
          <Accordion.Title className="bg-myBlue hover:bg-myPurple font-bold text-white text-xl focus:ring-2 focus:outline-none">
            පාඨමාලාවන් සඳහා මුදල් ගෙවිය හැකි ආකාර?
          </Accordion.Title>
          <Accordion.Content className="bg-myBlue bg-white border rounded-b-lg">
            <p className="mb-2  text-gray-500">
              පාඨමාලාවන් සඳහා පහත ආකාරයට මුදල් ගෙවීම සිදු කල හැක.
              <br />
              <br />
              <ul>
                <li>
                  - <strong> බැංකු රිසිට්පත් මගින්</strong>
                </li>
                <ul>
                  <li>
                    පාඨමාලාවට අදාල මුදල අපගේ බැංකු ගිණුමට බැර කල රිසිට්පත පහත
                    video වේ දැක්වෙන ආකාරයට upload කිරීමෙන් අදාල පාඨමාලාව මිලදී
                    ගත හැක. (‍රිසිට්පත upload කිරීමෙන් පැය 24ක් ඇතුලත අදාල
                    පාඨමාලාව සක්‍රීය වනු ඇත. )
                    <br />
                    <br />
                    <a target="_blank" href="https://youtu.be/GaKw7fkpZ9k">
                      Click here to see the video
                    </a>
                  </li>
                </ul>
                <br />
                {/* <li>
                  - <strong> Online Payments මගින්</strong>
                </li>
                <ul>
                  <li>
                    VISA, MASTERCARD හරහා. පහත video වේ දැක්වෙන ආකාරයට ගෙවීම්
                    සිදු කල හැක.
                  </li>
                  <br />
                  <a href="#">Click here to see the video</a>
                </ul> */}
              </ul>
            </p>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title className="bg-myBlue hover:bg-myPurple font-bold text-white text-xl focus:ring-2 focus:outline-none">
            තාක්ෂණික සහය සඳහා පිවිසෙන්න
          </Accordion.Title>
          <Accordion.Content className="bg-myBlue bg-white border rounded-b-lg">
            <p className="mb-2 text-gray-500 dark:text-gray-400">
              තාක්ෂණික සහය සඳහා support පිටුවට පිවිසෙන්න
              <br />
              <br />
              <Link to={"/support"}>click here</Link>
            </p>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title className="bg-myBlue hover:bg-myPurple font-bold text-white text-xl focus:ring-2 focus:outline-none rounded-b-lg">
            What should I do if I forget my password?
          </Accordion.Title>
          <Accordion.Content className="bg-myBlue bg-white border rounded-b-lg">
            <p className="mb-2 text-gray-500 dark:text-gray-400">
              If you forget your password, click the "Forgot Password?" link on
              the login page. You will receive an email with instructions to
              reset your password.
            </p>
          </Accordion.Content>
        </Accordion.Panel>
      </Accordion>
      {/* -----------------------FAQ------------------- */}
    </div>
  );
};

export default Home;
